import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Merge class lists so a caller's utility always beats the component default. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
